// @flow
import type { ActionsState } from '~/core/state/actions/types';

import { connect } from 'react-redux';
import { flowRight } from 'lodash/fp';
import Component from './component';
import { attemptCreateAction, attemptEditAction, attemptRemoveAction, cancelForm } from '~/core/state/actions/actions';
import { getAttributeDefinition } from '~/core/constants/actions';
import { getIconLocaleSuffix } from '~/core/state/config/selectors';
import { currentSavingState, getActionForm, listDevicesForActionAttribute } from '~/core/state/actions/selectors';
import { formToNewAction, formToEditAction } from '~/core/state/actions/utils';
import { getScheduleData } from '~/core/state/ui/schedule/selectors';
import { actionFormComponentId } from '~/core/utils/schedule';

const extendForm = (state: any): ?{} => {
    const form = getActionForm(state);

    if (form === 'none') {
        return;
    }

    const region = getIconLocaleSuffix(state);

    const extendGroup = group =>
        group.reduce((acc, event, index) => {
            const definition = getAttributeDefinition(event.type, region);
            // $FlowFixMe
            const devices = listDevicesForActionAttribute(state, {
                types: definition.devices || []
            }).filter(
                // check the device is not already used in another event of the same type
                device => !group.some((e, i) => e.type === event.type && i !== index && e.id === device.value)
            );
            return definition.devices && devices.length === 0 ? acc : [...acc, { ...event, definition, devices }];
        }, []);

    const extendGroups = form =>
        ['when', 'while', 'then'].reduce(
            (groups, group) => ({
                ...groups,
                [group]: extendGroup(form[group])
            }),
            {}
        );

    const extendedGroups = extendGroups(form);

    return {
        ...form,
        ...extendedGroups,
        ...(form.status === 'edit' ? { id: form.id } : {})
    };
};

const updateEventSchedule = (schedule: any) => (action: any) => {
    const findScheduleEventAndUpdateSchedule = (acc, event) => [
        ...acc,
        event.type === 'schedule'
            ? {
                  ...event,
                  settings: {
                      ...event.settings,
                      schedule: schedule.toJS()
                  }
              }
            : event
    ];
    return schedule
        ? {
              ...action,
              events: action.events.reduce(findScheduleEventAndUpdateSchedule, [])
          }
        : action;
};

const mapStateToProps = (state: { actions: ActionsState }) => {
    const region = getIconLocaleSuffix(state);
    const schedule = getScheduleData(state, { componentId: actionFormComponentId });
    const savingState = currentSavingState(state);

    return {
        extendedForm: extendForm(state),
        region,
        savingState,
        schedule
    };
};

const mapDispatchToProps = {
    attemptCreateAction,
    attemptEditAction,
    attemptRemoveAction,
    cancelForm
};

const mergeProps = ({ schedule, ...restStateProps }, dispatchProps, ownProps) => {
    const { extendedForm, region } = restStateProps;
    const { attemptCreateAction, attemptEditAction, loadForm, ...restDispatchProps } = dispatchProps;
    const updateSchedule = updateEventSchedule(schedule);

    return {
        ...restStateProps,
        ...restDispatchProps,
        ...ownProps,
        saveAction: (editedName: ?string) => {
            if (extendedForm) {
                const editedForm = editedName ? { ...extendedForm, name: editedName } : extendedForm;
                extendedForm.status === 'new'
                    ? flowRight(attemptCreateAction, updateSchedule, formToNewAction(region))(editedForm)
                    : flowRight(attemptEditAction, updateSchedule, formToEditAction(region))(
                          editedForm,
                          editedForm.id || ''
                      );
            }
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/action-canvas/index.js